define('controllers/zoom',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'debug',
    // services
    'services/i18n',
    'services/api',
    'services/session',
    // Contoller
    'src/controller/controller',
    // Views | Layout
    'views/app/zoom',
], function (
    // Libs
    _, Backbone, Mustache, U, DEBUG,
    // services
    i18n,
    API,
    Session,
    // controller
    Controller,
    // Views | Layout
    VZoomLayout
) {

    var ZoomCtrl = Controller.extend({
        authDefault: true,

        initialize: function(code) {
            this.code = code;
        },

        getLayoutInstance: function () {
            return new VZoomLayout();
        },

        process: function () {
            this.getLayout().loginWithZoom(this.code);
        }
    });

    return ZoomCtrl;
});

